class ScrollingContent {
  constructor(container) {
    this.container = container;
    this.index = this.container.querySelector('[data-scrolling-index]');
    this.timeout;
    this.scrollingItems = this.container.querySelectorAll(
      '[data-scrolling-item]'
    );
    this.links = this.container.querySelectorAll(
      '.scrolling-content__index-link'
    );
  }

  init() {
    if (this.scrollingItems.length > 0) {
      const activeLink = this.container.querySelector(
        `#${this.scrollingItems[0].id}`
      );
      activeLink.classList.add('scrolling-content__index-link--active');
    } else {
      console.warn('There are no elements in the scrolling content section.');
      return;
    }

    for (let link of this.links) {
      link.addEventListener('click', (e) => {
        e.preventDefault();

        const target = this.container.querySelector(link.getAttribute('href'));

        if (!target) {
          console.warn(`There is no target for ${link.getAttribute('href')}`);
          return;
        } else {
          target.scrollIntoView({
            behavior: 'smooth'
          });
        }
      });
    }

    window.addEventListener('scroll', (e) => {
      if (this.timeout) {
        window.cancelAnimationFrame(this.timeout);
      }

      this.timeout = window.requestAnimationFrame(() => {
        const containerRect = this.container.getBoundingClientRect();

        if (containerRect.top <= 0) {
          this.fixElements();
        } else if (containerRect.top > 0) {
          this.returnElementsToDefaultState();
        }
        if (window.innerHeight >= containerRect.bottom) {
          this.fixElementsBottom();
        }

        // get active item
        for (let item of this.scrollingItems) {
          const itemBoundingRect = item.getBoundingClientRect();

          if (
            itemBoundingRect.top <= window.innerHeight / 2 &&
            window.innerHeight / 2 < itemBoundingRect.bottom
          ) {
            document
              .querySelector('.scrolling-content__index-link--active')
              .classList.remove('scrolling-content__index-link--active');
            const link = document.querySelector(`a[href*=${item.id}]`);
            link.classList.add('scrolling-content__index-link--active');
          }
        }
      });
    });
  }

  fixElements() {
    this.index.classList.add('js-fixed');
    this.index.classList.remove('js-fixed-bottom');
  }

  fixElementsBottom() {
    this.index.classList.remove('js-fixed');
    this.index.classList.add('js-fixed-bottom');
  }

  returnElementsToDefaultState() {
    this.index.classList.remove('js-fixed');
    this.index.classList.remove('js-fixed-bottom');
  }
}

export default ScrollingContent;
